import $ from 'jquery';
import moment from 'moment';
import smsService from '../service/smsService';


$(document).ready(function() {

    const $sub_btn = $('.resend');
    const $timer = $('.timer');
    
    const formatTime = function(min, sec) {
        return `
            (${min}:${sec >= 10 ? sec : "0" + sec })
        `
    };
    
    const runCountDown = function(){
        let duration = moment.duration(5, 'minutes');
        let countDown = setInterval( () => {
            duration.subtract(1, 'seconds');
            $timer.text(formatTime(duration.minutes(), duration.seconds()));
            if( duration.asSeconds() <= 0 ) {
                clearInterval(countDown);
                $sub_btn.removeClass('resend-timer');
                $sub_btn.removeAttr('disabled');
                $sub_btn.removeAttr('style');
            }
        },1000);
    }
    
    runCountDown();
    
    $('.sms-form').on('submit', function(e){
        e.preventDefault();
        $sub_btn.attr('disabled', 'disabled');
        $sub_btn.addClass('resend-timer');
        $sub_btn.css('background-color', 'transparent');

        smsService.send({
            coupon_id: $sub_btn.data('coupon'),
            url_name: $sub_btn.data('url_name')
        }).then(resp => {
            if(resp.status){
                runCountDown();
            }
        }).catch(() => {
            $sub_btn.removeClass('resend-timer');
            $sub_btn.removeAttr('disabled');
            $sub_btn.removeAttr('style');
        });
    });

});